// 054 — resumen interno de laboratorio (HCU 2008, AM 000138), tabla simple de
// resultados. No figura en la HCU 2021: imprime la cita 'HCU 2008…', no SNS-MSP/HCU-form.xxx/2021 — ver `formularioResumenMsp.tsx`.
import { crearFormularioResumenMsp } from './formularioResumenMsp';

export const Formulario054 = crearFormularioResumenMsp({ codigo: '054', claveI18n: 'f054' });
